<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    width="80%"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="120px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="recruitName" label="职位名称">
            <el-input v-model="entityData.recruitName" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="recruitTypeDictKey" label="职位类型">
            <Combox
              v-model="entityData.recruitTypeDictKey"
              type-id="D90"
              :option-data="getComboxData('D90')"
              :add-client="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="recruitInfo" label="职位信息">
            <el-input v-model="entityData.recruitInfo" :rows="4" type="textarea" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="profession" label="专业">
            <el-input v-model="entityData.profession" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="degree" label="学位要求">
            <el-input v-model="entityData.degree" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="workYearFrom" label="工作年限">
            <el-input-number v-model="entityData.workYearFrom" clearable :controls="false" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="workYearTo" label="~">
            <el-input-number v-model="entityData.workYearTo" clearable :controls="false" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="requirement" label="岗位要求">
            <el-input v-model="entityData.requirement" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="ketizuFuzeren" label="课题组负责人">
            <el-input v-model="entityData.ketizuFuzeren" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="ketizuJianjie" label="课题组简介">
            <el-input v-model="entityData.ketizuJianjie" type="textarea" :rows="4" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="yanjiuLingyu" label="研究领域">
            <el-input v-model="entityData.yanjiuLingyu" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="suoshuXueke" label="所属学科">
            <el-input v-model="entityData.suoshuXueke" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="yanjiuFangxiang" label="研究方向">
            <el-input v-model="entityData.yanjiuFangxiang" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="suoshuDanwei" label="所属单位">
            <el-input v-model="entityData.suoshuDanwei" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="gongzuoDidian" label="工作地点">
            <el-input v-model="entityData.gongzuoDidian" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="daiyu" label="薪资待遇">
            <el-input v-model="entityData.daiyu" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="publishDTBegin" label="发布开始日期">
            <el-date-picker
              v-model="entityData.publishDTBegin"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="publishDTEnd" label="~">
            <el-date-picker
              v-model="entityData.publishDTEnd"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave()">保  存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
export default {
  components: { Combox },
  props: {
    value: { type: Boolean, default: false },
    entityKey: { type: Number, default: null }
  },
  data() {
    return {
      allComboxData: [],
      entityData: {},
      rules: {
        recruitName: [{ required: true, message: '请输入职位名称', trigger: 'change,blur' }],
        followMessage: [{ required: true, message: '请输入跟进详细', trigger: 'change,blur' }]
      }
    }
  },
  computed: {
    title() {
      return (this.entityKey ? '修改' : '新增') + '招聘信息'
    }
  },
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D90').then(res => {
      this.allComboxData = res.data.result
    })
  },

  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    handleClose() {
      this.$refs['entityData'].resetFields()
      this.$emit('input', false)
    },
    handleOpen() {
      const that = this
      let path = '/api/services/app/GR07/GetEditGR07'
      if (this.entityKey) {
        path += '?Id=' + this.entityKey
      }

      pathReq.getNoParams(path).then(res => {
        that.entityData = res.data.result.entityData
      })
    },
    /** 保存 */
    handleSave() {
      const that = this

      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const path = '/api/services/app/GR07/CreateOrUpdateGR07'

          const formData = {
            entityData: that.entityData
          }
          pathReq
            .dataUpdate(path, formData)
            .then(res => {
              that.$message.success('保存成功')
              this.$emit('save-success')
              this.$emit('input', false)
            })
        }
      })
    }
  }

}
</script>
